export default __webpack_public_path__ + "static/media/icon-users.3616a6b1.svg";